export class MachinesRequisitionIdReq {
    poNOs?: number;
    snapId?: number;
    constructor(
        poNOs?: number,
        snapId?: number
    ) {
        this.poNOs = poNOs;
        this.snapId = snapId;
    }
}